<section class="landing-login">
    <div class="banner-sec">
        <div class="landing-container">
            <div class="banner-textbox">
                <div class="banner-btnbox">
                    <a href="https://apps.apple.com/us/app/trucklots/id6472444340" class="banner-btn-outline">
                        IOS
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.trucklots.parkingdriver"
                        class="banner-btn-outline">
                        Android
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>